import { PromptShortcut } from '../../../../../../../common/ai/aiPromptShortcutTypes';
import { AiLocalAiConversation } from './aiToolStateTypes';

export enum AIConversationResultType {
    BOT_HISTORY = 'BOT_HISTORY',
    PROMPT_HISTORY = 'PROMPT_HISTORY',
    DEBUG_INFO = 'DEBUG_INFO',
}

export const CONVERSATION_HISTORY_LIMIT = 16;

export const PROMPT_MAX_TOKEN_LENGTH = 1024;
export const PROMPT_SHORTCUT_CONTEXT_LENGTH = 256;

export const DEFAULT_LOCAL_CONVERSATION_STATE: AiLocalAiConversation = {
    _id: '',
    title: '',
    fetching: false,
    fetched: false,
    streamingResults: false,
    streamingFollowupPrompts: false,
    error: null,
    results: [],
    selectedPromptShortcuts: [],
    previousSelectedPromptShortcuts: [],
};

export const GENERATE_MORE_PROMPT_SHORTCUT: PromptShortcut = {
    id: 'generate-more',
    promptText: 'Generate more like this',
    children: [],
};

export const ROOT_FOLLOWUP_PROMPT_SHORTCUT: PromptShortcut = {
    id: 'followup-root',
    isRoot: true,
    question: 'Build on these ideas',
    children: [GENERATE_MORE_PROMPT_SHORTCUT],
};

export const AI_TRANSITION_GROUP_DURATION = 400;

export enum AiSubmissionType {
    BUILT_IN = 'BUILT_IN',
    FOLLOW_UP = 'FOLLOW_UP',
    CUSTOM = 'CUSTOM',
}
